import { render, staticRenderFns } from "./OrderFindLimit.vue?vue&type=template&id=5e1112c1&scoped=true&"
var script = {}
import style0 from "./OrderFindLimit.vue?vue&type=style&index=0&id=5e1112c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e1112c1",
  null
  
)

export default component.exports